<p>Welcome to the Part IIB project selection pages <span *ngIf="!isProd" >(Test/Staging/Development)</span></p>

<a mat-button mat-raised-button color='primary' href="/auth/google">Login</a>
<a *ngIf="!isProd" mat-button mat-raised-button color='primary' href="/auth/local">Login (local)</a>
